import React, {useEffect, useState} from 'react';
import {getStateByPath} from "../../../../redux/selectors";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle, Spinner} from "reactstrap";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {
    ADD_STATE, REMOVE_STATE, setApp,
    setFilter,
    setForm,
    setItem, setLoading,
    setTableParams, setUdn,
    setViewMode
} from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {udnService} from "../../../../jwt/_services";
import HomeUdnForm from "./_form";
import {ModalFormContainer} from "../../../../components/confirmAlert/ModalFormContainer";

const HomeUdnSection = (props) => {
    const path = props?.path + '/udn';
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {  app, udn } = parentComponentState?.data || {};

    const {  domainObject, loading } = componentState?.data || {};



    const [logoImage, setLogoImage] = useState( null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect( () => {
        if( !app?.id || !udn?.id )
            return

        props.setApp(path, app);
        props.setUdn(path, udn);
        // Cargar datos de UDN
        genericIndexedActions.get(path, udnService, udn.id, app?.fbDataBase?.id)

    }, [ app, udn ]);

    useEffect(() => {
        if (!domainObject)
            return

        setUdnHeader();
    }, [domainObject]);

    const setUdnHeader = () => {
        let img;

        try {
            img = require("../../../../assets/images/logo/svg/" + domainObject?.code.toLowerCase() + ".svg");
        } catch (_) {
            //img = require("../../../../assets/images/icon/parks/svg/gpoxc-icon.svg");
        }

        setLogoImage(img);
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(HomeUdnForm, { path, data, Form: HomeUdnForm })
    }

    return <Card className={'home-udn-place'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <>
                <h2>{'Unidad de negocio'}</h2>
                <h5 className={'card-modal-uid'}> {'     uid: ' + (domainObject?.uid || '')}</h5>
            </>
            <div className="top-right">
                <GenericButton
                    style={'table'}
                    label={'Editar'}
                    toolTip={'Editar'}
                    icon={'fa-pen'}
                    permission={'edit'}
                    onClick={_ => editItem(domainObject)}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            {
                loading ? <Spinner animation="border"/> : <>
                    <img className={'home-udn-logo'} src={logoImage} alt={domainObject?.name}/>
                    <br/>
                    <h3>{domainObject?.langs?.find(l => l?.lang?.showOrder === 1)?.slogan || ''}</h3>
                    <h3>{domainObject?.langs?.find(l => l?.lang?.showOrder === 1)?.address || ''}</h3>
                </>
            }
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
    setApp,
    setUdn,
})
export default connect(mapStateToProps, mapActionsToProps)(HomeUdnSection)